const debounce = (cb: () => void, milliseconds = 300) => {
    let timeout: ReturnType<typeof setTimeout>;

    return () => {
        if (timeout) {
            clearTimeout(timeout);
        }

        timeout = setTimeout(cb, milliseconds);
    };
};

export default debounce;
